<template>
  <div>
    <v-icon color="var(--v-resBlue-darken1)" class="collapse-icon-container" @click.stop="toggleCollapse" v-if="params.data.isCollapsible && !params.data.isCollapsed">mdi-chevron-down</v-icon>
    <v-icon color="var(--v-resBlue-darken1)" class="collapse-icon-container" @click.stop="toggleCollapse" v-if="params.data.isCollapsible && params.data.isCollapsed">mdi-chevron-right</v-icon>
    <v-icon class="calculator-container" @click.stop="openCalculator" v-if="!params.data.isHistorical && !params.data.isCollapsible && params.data.glAccountId">mdi-calculator</v-icon>
    <div class="gl-title" :class="params.data.url ? 'clickable' : ''" @click="navigateToLink">
      {{params.data.label}}
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" class="ml-3">{{params.data.icon}}</v-icon>
        </template>
        <span>{{params.data.iconHoverText}}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'GLTitleCell',
    components: {
     
    },
    props: {

    },
    data: function () {
    
    },
    computed: {
    },
    methods: {
      navigateToLink(e) {
        if (this.params.data.url) {
          window.open(this.params.data.url, '_blank');
          if (e && e.preventDefault) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }
      },
      openCalculator() {
        this.params.openCalculator(this.params.data);
      },
      toggleCollapse() {
        //toggle collapse state on container
        this.params.data.isCollapsed = !this.params.data.isCollapsed
        //toggle collapse state on sub rows
        this.params.api.forEachNode((node) => { if (node.data.glAccountId == this.params.data.glAccountId && (node.data.year === 0 || node.data.year == this.params.data.year) && node.data.isHistorical == this.params.data.isHistorical) { node.data.isCollapsed = this.params.data.isCollapsed; localStorage.setItem(`${this.params.data.glAccountId + node.data.year}-collapsed_subrow`, this.params.data.isCollapsed); } })
        //refresh view
        this.params.api.refreshInMemoryRowModel()
        this.params.api.refreshView()
      }
    },
    async mounted() {

    }
  }
</script>

<style lang="scss" scoped>
  .calculator-container {
    position: absolute;
    left: 10px;
    top: 10px;
    z-index: 1;
    color: var(--v-resBlue-darken1)
  }
  .gl-title{
    position: absolute;
    right: 0px;
    display:inline;
  }
  .collapse-icon-container {
    top: 5px;
    left: 18px;
    position: absolute;
    color: var(--v-resBlue-darken1)
  }
  .gl-title.clickable:hover {
    color: var(--v-resBlue-darken1);
    text-decoration: underline;
    cursor: pointer; 
  }
</style>
